<template>

  <Blackbar v-show="!isPurePage"
    client-id="author-tool"
    :user-info="blackbarUserInfo"
    :is-show-sidebar.sync="isShowSidebar"
    :z-index="500"
    @login="login"
    @logout="logout"
    @changeAccount="changeAccount">
    <div class="cm-wrapper">

      <header class="cm-header">
        <cm-navigation class="menu"
          btnType="menu"
          type="2C"
          :category="device === $deviceSize.mobile ? 'mobile': 'default'"
          placement="right"
          :isCollapse="isCollapse"
          @click-collapse-btn="handleClickCollapseBtn">
          <template #left>
            <img src="@/assets/images/logo.png"
              width="209"
              height="72"
              class="menu__logo"
              alt="CMoney 作者專區" />
          </template>
          <template #center>
            <template v-if="device === $deviceSize.desktop">
              <cm-navigation-item v-for="(item, i) in displayMenu"
                :key="i"
                :class="{'cm-navigation__item--active' : nowMenu === item.to}"
                :to="menuTo(item.to)"
                :content="item.label" />
            </template>
          </template>
          <template #right>
            <div v-if="device === $deviceSize.mobile"
              class="dropdown">
              <cm-popup trigger="click"
                placement="bottom-end"
                :classes="['dropdown__panel']">
                <template>
                  <div class="dropdown__option"
                    v-for="(item, i) in displayMenu"
                    :key="i"
                    @click="handleClickOption(item)">
                    {{ item.label }}
                  </div>
                </template>
                <template #reference>
                  <cm-button shape="square"
                    size="small"
                    theme="secondary"
                    type="button"
                    variant="text">
                    <i style="font-size: 18px"
                      class="cm-icon-line-interface-menu-application"></i>
                  </cm-button>
                </template>
              </cm-popup>
            </div>
          </template>
        </cm-navigation>
      </header>
      <main class="cm-main">
        <div class="nav pt-6 pb-2">
          <div class="nav__container">
            <h1 class="nav__tit mb-1">
              {{ title }}
            </h1>
            <div class="nav__subtit">
              {{ desc }}
            </div>
          </div>
        </div>
        <div class="tabs">
          <template v-for="(item, i) in displayTab[nowMenu]">
            <router-link
              :key="item.to || i"
              @click.native="handleClickTab(item)"
              :class="tabLinkClasses(item)"
              :to="item.to"> {{ item.label }}</router-link>
          </template>
        </div>
        <div class="page">
          <div class="container">
            <keep-alive>
              <router-view />
            </keep-alive>
          </div>
        </div>
      </main>
    </div>
  </Blackbar>
</template>

<script>
import jwtDecode from 'jwt-decode';
import tabsData from '@/mixins/tabsData';
import Blackbar from '@/components/Blackbar.vue';
import { identifyUser, trackEvent, registerSuperProperties } from '@/utils/analytics/mixpanel';
import { getInitialDevice } from '@/utils/analytics/device';

export default {
  name: 'app',
  components: {
    Blackbar,
  },
  data() {
    return {
      purePage: ['login', 'logout'],
      isShowSidebar: false,
      observeResizeInstance: null,
      resizeFrameId: null,
      currentDevice: null,
      isCollapse: true,
      nowMenu: '',
      menu: [
        {
          label: '數據中心', to: '/dataCenter', desc: '掌握產品數據，提升創作影響力', elkParamName: 'Session_DataCenter',
        },
        {
          label: '同學會', to: '/forum', desc: '經營社群、累積流量、創造轉換', elkParamName: 'Session_Forum',
        },
        {
          label: '內容管理', to: '/manage', desc: '多元創作媒介，影響力無遠弗屆', elkParamName: 'Session_Content',
        },
        {
          label: '行銷工具', to: '/tool', desc: '掌握推廣及銷售的最佳時機', elkParamName: 'Session_MKTTool',
        },
        // TODO: 目前未規劃優選作家
        // { label: '優選作家', to: '/author', desc: '說明文字說明文字說明文字說明文字' },
        { label: '幫助中心', to: '/help', desc: 'CMoney團隊樂意協助您解決問題' },
      ],
      // 所有的 tab
      originalTab: {
        '/dataCenter': [{ label: '總覽', to: '/dataCenter/overview' },
          {
            label: '同學會', to: '/dataCenter/forum',
          },
          { label: 'APP', to: '/dataCenter/app' },
          { label: 'PC', to: '/dataCenter/pc' },
          { label: '產品銷售', to: '/dataCenter/product' }],
        '/forum': [
          {
            label: '貼文管理', to: '/forum/post',
          },
          // TODO: 目前未規劃專欄作家專區
          // { label: '專欄作家專區', to: '/forum/author' }
        ],
        '/manage': [
          {
            label: '影音', to: '/manage/video', elkParamName: 'Video',
          },
          {
            label: '網誌文', to: '/manage/article', elkParamName: 'Article',
          },
          {
            label: '直播', to: '/manage/live', elkParamName: 'Stream',
          },
        ],
        '/tool': [
          {
            label: 'APP推播', to: '/tool/push',
          },
          {
            label: 'APP短網址', to: '/tool/shortUrl',
          },
          // TODO: 目前未規劃折價券、線上抽獎
          // { label: '折價券', to: '/tool/coupon' },
          // { label: '線上抽獎', to: '/tool/draw' }
        ],
        // TODO: 目前未規劃每週表現、教學中心
        // '/author': [{ label: '每週表現', to: '/author/performance' },
        //   { label: '教學中心', to: '/author/teachingCenter' }],
        '/help': [{ label: '教學手冊', to: '/help/teach' },
          { label: '聯絡我們', to: '/help/contact' }],
      },
      nowTab: '',

      bounsPoint: 0,
    };
  },
  mixins: [tabsData],
  watch: {
    $route(val) {
      if (!this.isPurePage) {
        this.handleChangeMenuAndTab(val.path);
      }
    },
    // token更新時
    async tokenInfo() {
      // 先取得會員資訊
      await this.getUserInfo();
      // @const {Boolean} isGuest 是否為訪客
      const { isGuest } = this.userInfo;
      // 如果是訪客，則自己處理自動刷新token
      if (isGuest) {
        this.timeoutToUpdateToken();
        return;
      }
      this.$store.dispatch('auth/stopBeforeTimeout');
    },
    async isLogin() {
      // 沒有登入 return
      if (!this.isLogin) return;

      // 會員，取得資料(舊站)；router guard 可能已先取過，避免重複請求
      if (!this.$store.getters.isGetMemberInfo) await this.getMemberOldInfo();
      const userId = this.$store.getters.memberInfo.m;
      if (userId) identifyUser(userId);
      // 取得購物金(舊站)
      await this.getBounsPoint();
    },
    async nowMenu() {
      const elkParamName = this.menu.filter((item) => item.to === this.nowMenu)[0]?.elkParamName;
      if (!elkParamName) return;

      await this.addElkLog(elkParamName);
    },
    async nowTab() {
      // nowTab 沒有值時 return
      if (!this.nowTab || !this.nowMenu) return;

      // 沒有對應的值時 return
      if (!this.originalTab[this.nowMenu]) return;

      // 找出 elkParamName
      const { elkParamName } = this.originalTab[this.nowMenu].filter(
        (item) => item.to === this.nowTab,
      )[0];

      // 切換頁籤的時候埋入ELK
      if (elkParamName) {
        if (['/manage/video', '/manage/article', '/manage/live'].includes(this.nowTab)) {
          await this.addElkLog('Click__ContentSwitch', JSON.stringify({ tab: elkParamName }));
        }
      }
    },
  },
  computed: {
    isPurePage() {
      return this.purePage.includes(this.$route.name);
    },
    // token資訊
    tokenInfo() {
      return this.$store.getters['auth/getTokens'];
    },
    // 使用者資訊
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
    blackbarUserInfo() {
      return {
        name: this.memberInfo.nickName || '',
        login: this.isLogin || false,
        coins: this.bounsPoint,
        image: this.memberInfo.image || '',
        email: this.memberInfo.account || '',
      };
    },
    memberInfo() {
      return this.$store.getters.memberInfo;
    },
    clientId() {
      return this.$store.getters['auth/getClientId'];
    },
    device() {
      return this.$store.getters.getDevice;
    },
    displayMenu() {
      if (this.isAuthor) {
        // 拿掉沒有 tab 的 menu
        return this.menu.filter((item) => this.displayTab[item.to].length !== 0);
      }
      return [{ label: '幫助中心', to: '/help', desc: 'CMoney團隊樂意協助您解決問題' }];
    },
    // 基本應有的 tab
    tab() {
      const tab = { ...this.originalTab };

      // TODO: 目前未規劃專欄作家專區
      // tab['/forum'] = [
      //   { label: '專欄作家專區', to: '/forum/author' }];
      tab['/forum'] = [];

      tab['/manage'] = [
        {
          label: '網誌文', to: '/manage/article', elkParamName: 'Article',
        },
      ];

      // TODO: 目前未規劃折價券、線上抽獎
      // tab['/tool'] = [
      //   { label: '折價券', to: '/tool/coupon' },
      //   { label: '線上抽獎', to: '/tool/draw' }];
      tab['/tool'] = [];

      tab['/help'] = [{ label: '聯絡我們', to: '/help/contact' }];

      return tab;
    },
    // 最後顯示在畫面上的 tab
    displayTab() {
      const tab = { ...this.tab };
      // 如果同學會userId或groupId非0 數據中心不顯示同學會tab
      if (!this.forumIds.memberId) {
        tab['/dataCenter'] = tab['/dataCenter'].filter((item) => item.to !== '/dataCenter/forum');
      }
      // 如果appList為空 數據中心不顯示APP tab
      if (this.appList.length <= 0) {
        tab['/dataCenter'] = tab['/dataCenter'].filter((item) => item.to !== '/dataCenter/app');
      }
      // 如果pcList為空 數據中心不顯示PC tab
      if (this.pcList.length <= 0) {
        tab['/dataCenter'] = tab['/dataCenter'].filter((item) => item.to !== '/dataCenter/pc');
      }
      // 特別處理：若為「股市隱者」則不顯示產品銷售 tab (jira單號：UTILITY-1106)
      if (this.forumIds.memberId === 8326462) {
        tab['/dataCenter'] = tab['/dataCenter'].filter((item) => item.to !== '/dataCenter/product');
      }
      // 如果同學會userId或groupId非0 才顯示同學會貼文tab
      // 或是無敵帳號
      if (this.forumIds.userId !== 0 || this.forumIds.groupId !== 0 || this.isAdmin) {
        tab['/forum'] = [{
          label: '貼文管理', to: '/forum/post',
        },
        // TODO: 目前未規劃專欄作家專區
        // { label: '專欄作家專區', to: '/forum/author' },
        ];
      }

      // 如果作者有app短連結的app清單 才顯示app短連結管理的tab
      // 或是無敵帳號
      if (this.appListWithAppLink.length > 0 || this.isAdmin) {
        tab['/tool'] = [{
          label: 'APP短網址', to: '/tool/shortUrl',
        },
        // TODO: 目前未規劃折價券、線上抽獎
        // { label: '折價券', to: '/tool/coupon' },
        // { label: '線上抽獎', to: '/tool/draw' }
        ];
      }

      // 如果作者有app，才顯示推播管理、影音管理、直播管理三個tab
      if (this.appList.length > 0 || !this.appList) {
        if (tab['/tool'].length) {
          tab['/tool'] = [{
            label: 'APP推播', to: '/tool/push',
          },
          {
            label: 'APP短網址', to: '/tool/shortUrl',
          }];
        } else {
          tab['/tool'] = [{
            label: 'APP推播', to: '/tool/push',
          }];
        }

        tab['/manage'] = [{
          label: '影音', to: '/manage/video', elkParamName: 'Video',
        },
        {
          label: '網誌文', to: '/manage/article', elkParamName: 'Article',
        },
        {
          label: '直播', to: '/manage/live', elkParamName: 'Stream',
        }];
      }

      // 如果作者才有教學手冊的tab
      if (this.isAuthor) {
        tab['/help'] = [{ label: '教學手冊', to: '/help/teach' },
          { label: '聯絡我們', to: '/help/contact' }];
      }
      return tab;
    },
    title() {
      return this.menu.filter((item) => item.to === this.nowMenu)[0]?.label;
    },
    desc() {
      return this.menu.filter((item) => item.to === this.nowMenu)[0]?.desc;
    },
    isLogin() {
      return this.$store.getters.identity.isLogin;
    },
    isAdmin() {
      return this.$store.getters.identity.isAdmin;
    },
    isAuthor() {
      return this.$store.getters.identity.isAuthor;
    },
  },
  async created() {
    console.log('env: ', process.env.VUE_APP_ENV_NAME);
    this.init();
    if (!this.isPurePage) {
      this.handleChangeMenuAndTab(this.$router.path);
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.observeResizeInstance = new ResizeObserver((entries) => {
        // 使用 requestAnimationFrame 來延遲處理，避免 ResizeObserver 循環錯誤
        if (this.resizeFrameId) {
          cancelAnimationFrame(this.resizeFrameId);
        }

        this.resizeFrameId = requestAnimationFrame(() => {
          try {
            const width = entries[0]?.contentRect?.width;
            if (width === undefined) return;

            const newDevice = width <= 1024
              ? this.$deviceSize.mobile
              : this.$deviceSize.desktop;

            // 只有當設備類型真的改變時才更新 store，避免不必要的更新
            if (this.currentDevice !== newDevice) {
              this.currentDevice = newDevice;
              this.$store.dispatch('updateDevice', newDevice);
              // 同步更新 Mixpanel Device super property（與 store 保持一致）
              registerSuperProperties({ Device: getInitialDevice() });
            }
          } catch (error) {
            // 靜默處理 ResizeObserver 的循環錯誤
            // 這是一個已知的瀏覽器行為，不會影響功能
          }
        });
      });
      this.observeResizeInstance.observe(document.body);
    });
  },
  methods: {
    login() {
      this.$store.dispatch('auth/loginRedirectUnityPage', this.$route);
    },
    async logout() {
      await this.$store.dispatch('auth/logoutRedirectUnityPage', this.$route);
    },
    changeAccount() {
      this.$store.dispatch('auth/loginRedirectUnityPage', this.$route);
    },
    async init() {
      // OIDC manager 已於 main.js 在掛載前初始化
      this.checkUserToken();
    },
    // 檢查使用者client的token
    async checkUserToken() {
      // 先清除在localStorage中不完整授權的請求
      this.$store.dispatch('auth/clearIncompleteAuthorize');
      // @const {Object} userData 取得local端的使用者
      const userData = await this.$store.getters['auth/getUserTokens'];
      // local端有使用者的話，灌回 Vuex tokens（過期判斷在 action 內處理）
      if (userData) {
        await this.$store.dispatch('auth/hydrateFromOidc');
        return;
      }
      // 檢查登入狀態
      this.$store.dispatch('auth/checkIDPIsLogin');
      // local端沒有使用者，直接使用訪客(匿名)
      await this.timeoutToUpdateToken();
      this.getUserInfo();
    },
    // 定期刷新token的機制
    async timeoutToUpdateToken() {
      // @const {Object} tokens 目前的token資料
      const tokens = this.$store.getters['auth/getTokens'];
      if (!tokens.at) {
        return;
      }
      // @const {Object} payload access_token內的資訊
      // @const {Number} expTime access_token的有效時間
      // @const {Number} earlyTime 提前時間
      const payload = jwtDecode(tokens.at);
      const expTime = payload.exp * 1000;
      const earlyTime = 1000 * 60 * 10;
      // @const {Number} interval 時間區間(ms)(可以再減去時間安排提前刷新)
      // @const {Number} intervalTime 刷新時間區間(ms)
      const interval = expTime - Date.now() - earlyTime;
      const intervalTime = interval <= 0 ? 0 : interval;
      // 定時更新token
      // @const {Number} timeoutId 刷新token的id
      const timeoutId = setTimeout(() => {
        // 更新使用者token
        this.$store.dispatch('auth/getAnonymousTokens');
      }, intervalTime);
      this.$store.dispatch('auth/setTimeoutId', timeoutId);
    },
    async getUserInfo() {
      // @const {String} at access_token
      const { at } = this.$store.getters['auth/getTokens'];

      // 如果沒有 access_token 的話，則不往下繼續處理取得使用者資訊
      if (!at) {
        return;
      }
      // @const {Object} paload access_token內的資訊
      const payload = jwtDecode(at);
      const userInfo = {
        guid: payload.user_guid,
        id: parseInt(payload.sub, 10),
        isGuest: payload.is_guest,
      };
      // 訪客
      if (userInfo.isGuest) {
        userInfo.nickname = '訪客';
        userInfo.level = 0;
        userInfo.levelExp = 0;
        userInfo.levelExpToNext = 0;
        userInfo.pcoin = 0;
        userInfo.bio = '';
        userInfo.cellphone = '';
        this.$store.dispatch('setUserInfo', userInfo);
      }
    },
    async getBounsPoint() {
      const formData = new FormData();
      formData.append('act', 'GetAvailableBonusPoint');

      const response = await this.getBounsPointRequest(formData);

      if (response !== false) {
        this.bounsPoint = parseInt(response.data.AvailableBonusPoint, 10);
      }
    },
    handleChangeMenuAndTab(path) {
      if (path === '/') {
        this.nowMenu = '/dataCenter';
      } else if (path === undefined) {
        this.nowMenu = '';
      } else {
        this.nowMenu = `/${path.split('/')[1]}`;
      }
      this.nowTab = path;
    },
    handleClickCollapseBtn() {
      this.isCollapse = !this.isCollapse;
      this.isShowSidebar = true;
    },
    menuTo(to) {
      // 確保該路徑是否有顯示
      return this.displayTab[to][0].to;
    },
    handleClickOption(item) {
      this.$router.push(this.menuTo(item.to));
    },
    handleClickTab(item) {
      this.nowTab = item.to;
      const TAB_EVENT_MAP = {
        '/dataCenter/overview': { event: 'DataCenter_Tab_Clicked', tab: 'Overview' },
        '/dataCenter/forum': { event: 'DataCenter_Tab_Clicked', tab: 'Forum' },
        '/dataCenter/app': { event: 'DataCenter_Tab_Clicked', tab: 'App' },
        '/dataCenter/pc': { event: 'DataCenter_Tab_Clicked', tab: 'PC' },
        '/dataCenter/product': { event: 'DataCenter_Tab_Clicked', tab: 'ProductSales' },
        '/manage/video': { event: 'ContentManage_Tab_Clicked', tab: 'Video' },
        '/manage/article': { event: 'ContentManage_Tab_Clicked', tab: 'Blog' },
        '/manage/live': { event: 'ContentManage_Tab_Clicked', tab: 'Live' },
        '/tool/push': { event: 'MarketingTool_Tab_Clicked', tab: 'AppPush' },
        '/tool/shortUrl': { event: 'MarketingTool_Tab_Clicked', tab: 'ShortUrl' },
        '/help/teach': { event: 'HelpCenter_Tab_Clicked', tab: 'TeachingManual' },
        '/help/contact': { event: 'HelpCenter_Tab_Clicked', tab: 'ContactUs' },
      };
      const mapping = TAB_EVENT_MAP[item.to];
      if (mapping) {
        trackEvent(mapping.event, { Tab: mapping.tab });
      }
    },
    tabLinkClasses(item) {
      const classes = ['tabs__link'];

      if (item.to === this.nowTab) {
        classes.push('tabs__link--active');
      }

      return classes;
    },
  },
};
</script>

<style lang="scss">
body {
  background-color: #f9f9f9;
}

.menu {
  &__logo {
    object-fit: cover;
    height: 100%;
    @media screen and (max-width: 1024px) {
     width: 160px;
    }
  }

  .cm-navigation__center {
    align-self: stretch;
  }
}

.nav {
  background-color: $surface-basic;
  text-align: center;

  &__container {
    padding-left: 24px;
    padding-right: 24px;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    max-width: 1200px;
  }

  &__tit {
    font-weight: 600;
    font-size: 30px;
    line-height: 36px;
    letter-spacing: 0.004em;
  }

  &__subtit {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.002em;
  }
}

.dropdown {
  &__panel {
    min-width: 200px;
    background-color: $surface-basic;
    box-shadow: $shadow-4;
    padding-top: 8px;
    padding-bottom: 8px;
    border-radius: 4px;
  }

  &__option {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.002em;
    color: $text-primary;
    font-family: $font-family;
    padding: 12px 16px;
    cursor: pointer;

    &:hover {
      background-color: rgba(38, 38, 38, 0.04);
    }

    &:active {
      background-color: rgba(38, 38, 38, 0.13);
    }
  }
}

.tabs {
  background-color: $surface-basic;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 28px;
  border-bottom: 1px solid $surface-border;

  &__link {
    max-height: 44px;
    display: block;
    box-sizing: border-box;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.002em;
    color: $text-secondary;
    padding: 12px 2px;
    text-decoration: none;

    &--active {
      border-bottom: 1px solid $primary-basic;
      font-weight: 600;
      color: $primary-basic;
    }
  }

  @media screen and (max-width: 1024px) {
    position: sticky;
    top: 0;
    z-index: 20;
  }
}

.page {
  padding-top: 15px;
  padding-bottom: 15px;
  background-color: #f9f9f9;
}

.container {
  max-width: 1200px;
  padding-left: 24px;
  padding-right: 24px;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
  @media screen and (max-width: 1024px) {
    padding-left: 16px;
    padding-right: 16px;
  }
}

// btn
.btn {
  padding: 0.333em 0.667em;
  font-size: 1rem;
  font-weight: 400;
  border-radius: 3px;
  border: none;
  background-color: transparent;
  cursor: pointer;
}

.btn:disabled {
  pointer-events: none;
}

.btn-primary {
  background-color: #33bdef;
  color: #fff;
}

.btn-cancel {
  background-color: #c2c2c2;
  color: #fff;
  border: none;
}

.btn-primary:hover {
  background-color: #5eacdd;
}

.btn-cancel:hover {
  background-color: #928f8f;
}

//shortSelect
.shortSelect {
  padding: 5px;
  font-size: 14px;
  border-color: #d9d9d9;
  border-radius: 4px;
}

// v-select
.v-select {
  margin-right: 10px;
  border-color: #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  width: 250px;
}

.v-select .vs__dropdown-menu {
  box-sizing: border-box;
  max-width: 250px;
}

.v-select .vs__dropdown-option {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v-select .vs__selected-options {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v-select .vs__dropdown-toggle {
  height: 30px;
}

.vs__search:disabled {
  margin-top: 0;
  height: fit-content;
}

.vs--open .vs__search {
  min-width: 150px;
}

.vs--open .vs__search:disabled {
  margin-top: 0;
  border: 1px solid red;
}

.v-select .vs__dropdown-menu {
  overflow-y: auto;
  overflow-x: auto;
  width: fit-content;
  min-width: 100%;
}

.vs--open .vs__selected {
  margin-top: 4px;
  position: relative;
}

.vs--open .vs__selected {
  position: absolute;
}

.vs__dropdown-toggle {
  height: fit-content;
}
.vs__search {
  height: 0;
}
.vs--open .vs__search {
  height: auto;
}

@media screen and (max-width: 480px) {
  .v-select .vs__dropdown-menu {
    max-width: 100%;
  }
  .v-select {
    min-width: 100%;
  }
}

// tooltip
.tooltip {
  position: relative;
  cursor: pointer;
}

.tooltip:hover .tooltip__text {
  display: inline-block;
}

.tooltip__text {
  position: absolute;
  display: none;
}

// img
.img {
  -o-object-fit: contain;
  object-fit: contain;
  vertical-align: bottom;
  width: 100%;
  height: 100%;
}
</style>
